'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contract_typeAttribute = require('./contract_type.attribute.document');

Object.defineProperty(exports, 'contract_type', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_contract_typeAttribute).default;
  }
});

var _date_of_lossAttribute = require('./date_of_loss.attribute.document');

Object.defineProperty(exports, 'date_of_loss', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_date_of_lossAttribute).default;
  }
});

var _effective_dateAttribute = require('./effective_date.attribute.document');

Object.defineProperty(exports, 'effective_date', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_effective_dateAttribute).default;
  }
});

var _effective_datetimeAttribute = require('./effective_datetime.attribute.document');

Object.defineProperty(exports, 'effective_datetime', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_effective_datetimeAttribute).default;
  }
});

var _expiration_dateAttribute = require('./expiration_date.attribute.document');

Object.defineProperty(exports, 'expiration_date', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_expiration_dateAttribute).default;
  }
});

var _filenameAttribute = require('./filename.attribute.document');

Object.defineProperty(exports, 'filename', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_filenameAttribute).default;
  }
});

var _issue_dateAttribute = require('./issue_date.attribute.document');

Object.defineProperty(exports, 'issue_date', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_issue_dateAttribute).default;
  }
});

var _rental_rate_idAttribute = require('./rental_rate_id.attribute.document');

Object.defineProperty(exports, 'rental_rate_id', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_rental_rate_idAttribute).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}